export const STALE_CLIENT_REMINDER_INTERVAL_MS = 60 * 60 * 1000;

export interface StaleClientToastState {
  readonly staleKey: string | null;
  readonly shownKey: string | null;
  readonly dismissedAtMs: number | null;
}

export type StaleClientToastPlan =
  | { readonly action: "none" }
  | { readonly action: "show" }
  | { readonly action: "wait"; readonly delayMs: number };

export function planStaleClientToast(
  state: StaleClientToastState,
  nowMs: number,
  reminderIntervalMs: number = STALE_CLIENT_REMINDER_INTERVAL_MS,
): StaleClientToastPlan {
  if (state.staleKey === null) {
    return { action: "none" };
  }
  if (state.shownKey !== state.staleKey) {
    return { action: "show" };
  }
  if (state.dismissedAtMs === null) {
    return { action: "none" };
  }
  const delayMs = state.dismissedAtMs + reminderIntervalMs - nowMs;
  return delayMs <= 0 ? { action: "show" } : { action: "wait", delayMs };
}
